<!--
  ~ Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
  ~ This software is the proprietary information of NEXTWELL INTL SRL.
  ~ Use is subject to license and non-disclosure terms
  -->

<div class='subscription-wrapper card w-100' [ngClass]="{'border-red' : subscription?.private}">

  <div class='body'>
    <ng-content select='[ribbon]'></ng-content>
    <div class='visibility'
         *ngIf='subscription?.private'><span> {{ 'company.subscription-type.private' | translate }}</span></div>
    <div class='name pt'> {{ subscription?.typeName }}</div>
    <div class='price'> {{ subscription?.subscriptionPrice }} {{ subscription?.subscriptionCurrency }}</div>
    <div class='credit-start'
         *ngIf='subscription?.creditStart !== null'> {{ subscription?.creditStart }} {{ 'company.subscription-type.actions.creditStart' | translate }}
    </div>

    <div class='price-per-extra-credit' *ngIf='subscription?.pricePerExtraCredit !== null'>
      {{ subscription?.pricePerExtraCredit }} {{ subscription?.subscriptionCurrency }} {{ 'company.subscription-type.actions.pricePerExtraCredit' | translate }}
    </div>

    <div class='actions mt-lg'>

      <div class='action pb-sm'>
        <div class='icon'><i class='ui-icon-check'></i></div>
        <div class='text ml-xs'>
          <h3
            class='text-line action-title'> {{ 'company.subscription-type.actions.info' | translate }} </h3>

        </div>
      </div>

      <div class='action pb-sm' *ngFor='let action of subscription?.actionDefinitionVos'>

        <div class='icon'><i class='ui-icon-check'></i></div>
        <div class='text'>
          <h3
            class='text-line action-title'> {{ 'company.subscription-type.actions.' + action.actionName | translate }} </h3>
          <div
            class='text-line'> {{ action.monthlyIncludedAmount }} {{ 'company.subscription-type.actions.monthlyIncludedAmount' | translate }}
          </div>
          <div
            class='text-line'> {{ 'company.subscription-type.actions.actionCost' | translate }} {{ action.actionCost }} {{ 'company.subscription-type.actions.credits' | translate }}
          </div>
        </div>
      </div>
    </div>

    <div>
      <well-collapsible-text [content]='subscription?.details' [minLength]='200'></well-collapsible-text>
    </div>
  </div>

  <div class='footer mt-lg'>
    <ng-content></ng-content>
  </div>

</div>


